module.exports = __webpack_public_path__ + "static/media/YM13_1.c21089b2.jpg";